// extracted by mini-css-extract-plugin
export var root = "SingleCardDivider-module--root--1AG4T";
export var icon = "SingleCardDivider-module--icon--2d4oX";
export var left = "SingleCardDivider-module--left--lX78y";
export var right = "SingleCardDivider-module--right--24573";